export default __webpack_public_path__ + "static/media/CoralIMGGroup.3d09da66.svg";